import { render, staticRenderFns } from "./ProjectViewSidebarMessagesCard.vue?vue&type=template&id=c5eb16b6&scoped=true"
import script from "./ProjectViewSidebarMessagesCard.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarMessagesCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectViewSidebarMessagesCard.vue?vue&type=style&index=0&id=c5eb16b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5eb16b6",
  null
  
)

export default component.exports